/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { useIntl } from 'react-intl';
import { Navbar } from '@micromag/core/components';
import { useUrlGenerator } from '@micromag/core/contexts';
// import { PropTypes as MicromagPropTypes } from '@micromag/core';

import { useAuth as useAuthContext } from '../../contexts/AuthContext';
import { useOrganisation } from '../../contexts/OrganisationContext';

import MainGuestMenu from '../menus/MainGuest';
import MainMenu from '../menus/Main';
import Breadcrumbs from '../partials/Breadcrumbs';

import LogoIcon from '../icons/Logo';

import styles from '../../../styles/navbars/navbar.module.scss';

const propTypes = {
    nav: PropTypes.array, // eslint-disable-line
    subnav: PropTypes.array, // eslint-disable-line
    className: PropTypes.string,
};

const defaultProps = {
    nav: null,
    subnav: null,
    className: null,
};

const MainNavbar = ({ nav, subnav, className }) => {
    const { loggedIn } = useAuthContext();
    const organisation = useOrganisation();
    const url = useUrlGenerator();
    const { locale = 'fr' } = useIntl();

    return (
        <Navbar
            theme="dark"
            brand={<LogoIcon className={classNames([styles.logo, 'color-primary'])} />}
            brandLink={organisation === null ? url('organisations') : url('home')}
            brandClassName={classNames(['d-none', 'd-lg-inline-block'])}
            breadCrumbsClassName={classNames([styles.breadcrumbs, 'text-truncate'])}
            breadcrumbs={
                nav !== null ? <Breadcrumbs items={nav} className={styles.breadcrumb} /> : null
            }
            className={classNames([styles.container, { [className]: className !== null }])}
            collapseClassName={styles.collapseClassName}
            withoutCollapseToggle
            noWrap
        >
            {subnav !== null ? subnav : null}
            {loggedIn ? (
                <MainMenu
                    locale={locale}
                    className="navbar-nav ms-auto position-relative"
                    itemClassName="nav-item"
                    linkClassName="nav-link"
                    dropdownAlign="end"
                    dropdownClassName="position-absolute"
                />
            ) : (
                <MainGuestMenu
                    locale={locale}
                    className="navbar-nav flex-row ms-auto position-relative"
                    itemClassName="nav-item"
                    linkClassName="nav-link"
                />
            )}
        </Navbar>
    );
};

MainNavbar.propTypes = propTypes;
MainNavbar.defaultProps = defaultProps;

export default MainNavbar;
